import {Fragment} from 'react';
import {BlockStack} from '@shopify/polaris';

import {TranslatableField} from '../../../types';
import {FieldStatus} from '../FieldStatus';

import Styles from './FieldStatusDetails.scss';

export interface Props {
  gidKey: TranslatableField['gidKey'];
  dirty: boolean;
  status?: TranslatableField['status'];
}

export function FieldStatusDetails({status, gidKey, dirty}: Props) {
  if (!status) return null;

  const {machineTranslated, updatedAt} = status;
  const statuses = [];

  if (dirty) {
    statuses.push(<FieldStatus status="Edited" detailed />);
  } else {
    if (machineTranslated) {
      statuses.push(<FieldStatus status="AutoTranslated" detailed />);
    }

    if (updatedAt) {
      statuses.push(
        <FieldStatus status="LastSaved" detailed updatedAt={updatedAt} />,
      );
    }
  }

  if (!statuses.length) return null;

  const statusMarkup = statuses.map((markup) => (
    <Fragment key={`${status}-${gidKey}`}>{markup}</Fragment>
  ));

  return (
    <div className={Styles.FieldStatus}>
      <BlockStack gap="100" align="center">
        {statusMarkup}
      </BlockStack>
    </div>
  );
}
